export default "__VITE_ASSET__LvMDKC7$__"